import 'intersection-observer';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

// Console-polyfill. MIT license.
// https://github.com/paulmillr/console-polyfill
// Make it safe to do console.log() always.
(function (global) {
    if (!global.console) {
        global.console = {};
    }
    var con = global.console;
    var prop;
    var method;
    var dummy = function () {};
    var properties = ['memory'];
    var methods = (
        'assert,clear,count,debug,dir,dirxml,error,exception,group,' +
        'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
        'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn,timeLog,trace'
    ).split(',');
    while ((prop = properties.pop())) {
        if (!con[prop]) {
            con[prop] = {};
        }
    }
    while ((method = methods.pop())) {
        if (!con[method]) {
            con[method] = dummy;
        }
    }

    // keeping system time in the Date object
    Object.defineProperty(global.Date, 'systemNow', {
        value: Date.now,
    });

    // Detect avif support, add class to body
    var image = new Image();
    image.onerror = function() {
        if (document.body) {
            document.body.classList.add('no-avif');
        }
    };
    image.onload = function() {
        if (document.body) {
            document.body.classList.add('avif');
        }
    };
    image.src =
        'https://assets.launcher-3x4l6n-int.com/webiframe-assets/shared/images/non-branded/betgames.avif';

    // Using `this` for web workers & supports Browserify / Webpack.
})(typeof window === 'undefined' ? this : window);

// Array.flat polyfill for Chrome 60 compatibility (Chrome 69+)
if (!Array.prototype.flat) {
    Array.prototype.flat = function(depth) {
        depth = depth === undefined ? 1 : Number(depth);

        function flattenArray(arr, currentDepth) {
            var result = [];
            for (var i = 0; i < arr.length; i++) {
                if (Array.isArray(arr[i]) && currentDepth > 0) {
                    result = result.concat(flattenArray(arr[i], currentDepth - 1));
                } else {
                    result.push(arr[i]);
                }
            }
            return result;
        }

        return flattenArray(this, depth);
    };
}

// Array.flatMap polyfill for Chrome 60 compatibility (Chrome 69+)
if (!Array.prototype.flatMap) {
    Array.prototype.flatMap = function(callback, thisArg) {
        return this.map(callback, thisArg).flat();
    };
}

// Element.getAttributeNames polyfill for Chrome 60 compatibility (Chrome 61+)
// This is needed for react-tooltip to work in older browsers
if (!Element.prototype.getAttributeNames) {
    Element.prototype.getAttributeNames = function() {
        var attributes = this.attributes;
        var names = [];
        for (var i = 0; i < attributes.length; i++) {
            names.push(attributes[i].name);
        }
        return names;
    };
}
